import { trigger, state, style, transition, animate } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { ICheers } from 'app/models/cheers';
import { IKegVM } from 'app/models/keg';
import { ITap, ITapVM } from 'app/models/tap';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-cornykeg09-svg',
  templateUrl: './cornykeg09-svg.component.svg',
  styleUrls: ['./cornykeg09-svg.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  animations: [
    trigger("cheers", [
      state(
        "initial",
        style({
          //backgroundColor: "#fff471",
          backgroundColor: "--app-background-shade",
        })
      ),
      state(
        "final",
        style({
          //backgroundColor: "white",
          backgroundColor: "--app-background-shade",
        })
      ),
      transition("*=>final", animate("800ms")),
      transition("*=>initial", animate("800ms")),
    ]),
  ],
})
export class CornyKeg09SvgComponent implements OnChanges {

  @Input() item!: IKegVM;

  cheers$!: Observable<ICheers>;


  height!: number;
  y!: number;
  bubbleEnd!: number;

  constructor() {
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (!!this.item) {
      const totHeight = 97;
      const startY = 153;
      const factor = this.item.amount <= 0 ? 0 : this.item.amount / this.item.size;
      const height = factor <= 0 ? 0 : totHeight * factor;

      this.height = height;

      this.y = startY + (totHeight - height);

      this.bubbleEnd = this.y + 5;
    }
  }


}
